import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { personalizedBannerWatcher } from '@/model/personalizedBanners/kraken';

export const watchPersonalizedBanners = () => {
  return asyncCallback(
    async (
      callback: Sender<
        | {
            type: 'PERSONALIZED_BANNERS_UPDATED';
            payload: { banners: { container: string; rendered: boolean }[] };
          }
        | {
            type: 'VIEW_CATEGORY_ROUTE_ITEM_CLICK';
            payload: {
              slug: string;
              isPersonalizedBanner: boolean;
              path: string;
            };
          }
      >
    ) => {
      return await personalizedBannerWatcher({ callback });
    }
  );
};
